export function getPrettyTime(time_in_s) {
    const SECONDS_IN_MINUTE = 60;
    const SECONDS_IN_HOUR = 3600;
    if (time_in_s >= SECONDS_IN_HOUR) {
        const hours = Math.floor(time_in_s / SECONDS_IN_HOUR);
        const minutes = Math.floor((time_in_s % SECONDS_IN_HOUR) / 60);
        return hours + " h " + minutes + " mn";
    } else if (time_in_s >= SECONDS_IN_MINUTE) {
        const minutes = Math.floor(time_in_s / SECONDS_IN_MINUTE);
        return minutes + " mn";
    }
    return time_in_s + " s";
}

export function getPrettyDistance(distance_in_meters) {
    const METERS_IN_KILOMETERS = 1e3;
    if (distance_in_meters >= METERS_IN_KILOMETERS) {
        const km = Math.floor(distance_in_meters / METERS_IN_KILOMETERS);
        const meters = Math.floor(distance_in_meters % METERS_IN_KILOMETERS);
        return km + " km " + meters + " m";
    }
    return distance_in_meters + " m";
}

export function httpGET(url, header=null) {
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        request.open('GET', url);
        if (header != null) {
            request.setRequestHeader(header.name, header.value)
        }
        request.onreadystatechange = function() {
            if (this.readyState === 4) {
                if (this.responseText === "") {
                    reject("Failed to join " + url)
                    return;
                }
                resolve(this.responseText);
            }
        };
        request.send();
    });
}

export function httpPOST(url, payload, headers=null) {
    return new Promise((resolve) => {
        let request = new XMLHttpRequest();
        request.open('POST', url);
        
        request.onreadystatechange = function() {
            if (this.readyState === 4) {
                if (this.responseText === "") {
                    // reject("No response");
                    // console.log("httpPOST: Empty response")
                }
                resolve(this.responseText);
            }
        };
        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        if (headers) {
            for (let header_name of Object.keys(headers)) {
                request.setRequestHeader(header_name, headers[header_name]);
            }
        }
        if (payload.__proto__ == String()) {
            request.send(payload);
        } else {
            request.send(JSON.stringify(payload));
        }        
    });
}
